import { useState, useCallback, useEffect, useRef } from 'react';

const useRetryApi = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const isMounted = useRef(true);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const safeSetState = (setter, value) => {
    if (isMounted.current) {
      setter(value);
    }
  };

  const retryApiCall = useCallback(async (apiFn, params, maxRetries = 3, delay = 1000) => {
    safeSetState(setLoading, true);
    safeSetState(setError, null);

    let retries = 0;

    while (retries < maxRetries) {
      try {
        const result = await apiFn(params);
        safeSetState(setLoading, false);
        return result;
      } catch (err) {
        retries++;
        console.error(`API call failed (attempt ${retries}):`, err);

        if (retries === maxRetries) {
          safeSetState(setError, err);
          safeSetState(setLoading, false);
          return null;
        }

        await new Promise((resolve) => setTimeout(resolve, delay * retries));
      }
    }
  }, []);

  return { retryApiCall, loading, error };
};

export default useRetryApi;